import React, { FC } from 'react';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  EmmaSpace,
  EmmaText,
} from '@axa-asia/emma-stylesheet';
import { gaClickAbleElement } from '../../../../../utils/generalGaEventAnalytics';
import { useSelector } from 'react-redux';
import {
  getChangeAddressLabels,
  getNewAddress,
} from '../../../selectors/changeAddressSelector';
import { resolveLocalizedText } from '../../../../../utils';

type ConfirmAddressDialogProps = {
  isShow: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmAddressDialog: FC<ConfirmAddressDialogProps> = ({
  isShow,
  isLoading,
  onConfirm,
  onClose,
}) => {
  const { confirmBtnLabel, editBtnLabel, verifyCorrespondenceAddress } =
    useSelector(getChangeAddressLabels);
  const {
    addrLine1,
    addrLine2,
    addrLine3,
    addrLine4,
    districtAddress,
    country,
  } = useSelector(getNewAddress);

  return (
    <Dialog show={isShow}>
      <DialogHeader>
        <span>{resolveLocalizedText(verifyCorrespondenceAddress)}</span>
      </DialogHeader>
      <DialogBody>
        <div
          className={EmmaText['BodyTextL/short-paragraph-15em/Left/MineShaft']}
        >
          <div>{addrLine1}</div>
          <div>{addrLine2}</div>
          <div>{addrLine3}</div>
          <div>{`${addrLine4}${
            addrLine4 ? ' ' : ''
          }${districtAddress} ${country}`}</div>
        </div>
      </DialogBody>
      <DialogFooter>
        <div>
          <div>
            <button
              className={`emma-stylesheet-primary-default-button ${
                isLoading
                  ? 'emma-stylesheet-left-default-loading-icon-button'
                  : ''
              }`}
              onClick={() => {
                gaClickAbleElement(
                  resolveLocalizedText(confirmBtnLabel),
                  'Please verify your new correspondence address',
                );
                onConfirm();
              }}
            >
              {resolveLocalizedText(confirmBtnLabel)}
            </button>
          </div>
          <div className={EmmaSpace.mt8}>
            <button
              className="emma-stylesheet-primary-ghost-button"
              onClick={() => {
                gaClickAbleElement(
                  resolveLocalizedText(editBtnLabel),
                  'Please verify your new correspondence address',
                );
                onClose();
              }}
            >
              {resolveLocalizedText(editBtnLabel)}
            </button>
          </div>
        </div>
      </DialogFooter>
    </Dialog>
  );
};

export default React.memo(ConfirmAddressDialog);
